import axios from '@/assets/js/axios.js'
import { PERMISSION_SERVICE_API } from './apis'
// 权限列表
export function list (params) {
  return axios({
    url: PERMISSION_SERVICE_API.RIGHT_ACCESS_LIST,
    method: 'post',
    data: params
  })
}
// 根据id获取对应的数据
export function accessForId (params) {
  return axios({
    url: PERMISSION_SERVICE_API.RIGHT_ACCESS + '/' + params,
    method: 'get'
  })
}
// 添加权限
export function addAccess (params) {
  return axios({
    url: PERMISSION_SERVICE_API.RIGHT_ACCESS,
    method: 'post',
    data: params
  })
}
// 修改用户信息
export function editAccess (params) {
  return axios({
    url: PERMISSION_SERVICE_API.RIGHT_ACCESS,
    method: 'put',
    data: params
  })
}
// 删除用户信息
export function deleteAccess (params) {
  return axios({
    url: PERMISSION_SERVICE_API.RIGHT_ACCESS + '/' + params,
    method: 'DELETE'
  })
}
// 删除用户信息
export function listByButtonId (params) {
  return axios({
    url: PERMISSION_SERVICE_API.RIGHT_ACCESS_LIST_BY_BUTTON_ID,
    method: 'get',
    params: params
  })
}
